/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { SnackbarKey, useSnackbar } from 'notistack';

function SnackbarCloseButton({ snackbarKey }: { snackbarKey: SnackbarKey }): JSX.Element {
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton onClick={() => closeSnackbar(snackbarKey)} aria-label="discard notification">
      <CloseIcon />
    </IconButton>
  );
}

export default SnackbarCloseButton;
